import { apiClient, ApiResponse } from './client'

export type RecoveryPurpose = 'find-id' | 'password-reset'

export interface FindIdResult { handles: string[] }
export interface RecoveryStudent { organizationMemberId: number; displayName: string }
export interface PasswordResetVerifyResult { resetToken: string; students: RecoveryStudent[] }

const base = '/lc/auth/recovery'

export async function requestRecoveryCode(
  purpose: RecoveryPurpose, name: string, guardianPhone: string,
): Promise<void> {
  await apiClient.post<ApiResponse<void>>(`${base}/${purpose}/request`, { name, guardianPhone })
}

export async function verifyFindId(
  name: string, guardianPhone: string, code: string,
): Promise<FindIdResult> {
  const res = await apiClient.post<ApiResponse<FindIdResult>>(
    `${base}/find-id/verify`, { name, guardianPhone, code },
  )
  return res.data.data!
}

export async function verifyPasswordReset(
  name: string, guardianPhone: string, code: string,
): Promise<PasswordResetVerifyResult> {
  const res = await apiClient.post<ApiResponse<PasswordResetVerifyResult>>(
    `${base}/password-reset/verify`, { name, guardianPhone, code },
  )
  return res.data.data!
}

export async function confirmPasswordReset(
  resetToken: string, organizationMemberId: number, newPassword: string,
): Promise<void> {
  await apiClient.post<ApiResponse<void>>(
    `${base}/password-reset/confirm`, { resetToken, organizationMemberId, newPassword },
  )
}
